import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  it: {
    "nav.fleet": "Flotta", "nav.delivery": "Consegna", "nav.offers": "Offerte LT", "nav.contacts": "Contatti",
    "nav.account": "Area clienti", "nav.partner": "Hotel e B&B", "nav.admin": "Gestionale",
    "hero.title1": "Noleggia", "hero.title2": "la libertà.",
    "hero.sub": "Dal Golfo di Napoli ovunque vuoi.", "hero.sub2": "Consegna da 5 a 90 min, senza carta di credito.",
    "search.location": "Località", "search.pickup": "Ritiro", "search.dropoff": "Consegna", "search.cta": "Cerca auto",
    "search.days": "giorni", "search.delivery_est": "consegna",
    "fleet.title": "La nostra flotta a Napoli", "fleet.see_all": "Vedi tutti",
    "fleet.choose": "Scegli modello", "fleet.demo": "Anteprima auto",
    "footer.tagline": "Noleggia la libertà. Dal Golfo di Napoli ovunque vuoi — consegna gratuita da 5 a 90 minuti in base alla distanza, senza carta di credito.",
    "footer.contacts": "Contatti reali",
    "booking.note": "La richiesta non è una conferma: prezzo e disponibilità sono confermati dal personale (entro 30 min in orario d'ufficio).",
    "cancel.policy": "Cancellazione gratuita fino a",
    "common.hours_before": "ore prima",
    "lang.label": "Lingua",
  },
  en: {
    "nav.fleet": "Fleet", "nav.delivery": "Delivery", "nav.offers": "LT Offers", "nav.contacts": "Contact",
    "nav.account": "Customer area", "nav.partner": "Hotels & B&B", "nav.admin": "Dashboard",
    "hero.title1": "Rent", "hero.title2": "your freedom.",
    "hero.sub": "From the Gulf of Naples, anywhere you want.", "hero.sub2": "Delivery from 5 to 90 min, no credit card needed.",
    "search.location": "Location", "search.pickup": "Pickup", "search.dropoff": "Drop-off", "search.cta": "Find a car",
    "search.days": "days", "search.delivery_est": "delivery",
    "fleet.title": "Our fleet in Naples", "fleet.see_all": "See all",
    "fleet.choose": "Choose model", "fleet.demo": "Car preview",
    "footer.tagline": "Rent your freedom. From the Gulf of Naples, anywhere — free delivery from 5 to 90 minutes depending on distance, no credit card.",
    "footer.contacts": "Real contacts",
    "booking.note": "This is a request, not a confirmation: price and availability are confirmed by our staff (within 30 min during office hours).",
    "cancel.policy": "Free cancellation up to",
    "common.hours_before": "h before",
    "lang.label": "Language",
  },
};

const LangCtx = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

// B5 (ITERAZIONE 4): traduzione dell'AREA CLIENTI — dizionario testo→testo applicato con tr(s):
// le stringhe non presenti restano in italiano (degradazione elegante, nessuna chiave da inventare).
const ACC_EN = {
  "Le mie informazioni": "My details", "Crea il tuo account": "Create your account",
  "Documenti (carta d'identità e patente)": "Documents (ID card and driving licence)",
  "Carta d'identità": "ID card", "Patente di guida": "Driving licence",
  "I tuoi documenti": "Your documents", "Allega documento": "Attach document", "Sostituisci foto": "Replace photo",
  "Scatta una foto": "Take a photo", "Salva": "Save", "Annulla": "Cancel",
  "Ho avuto un incidente": "I've had an accident",
  "Procedura guidata: documenti, foto danni (min 4), GPS e la tua versione dei fatti. Pratica inviata subito al gestionale.": "Guided procedure: documents, damage photos (min 4), GPS and your statement. Claim sent straight to the office.",
  "Apri la procedura guidata": "Open the guided procedure",
  "Le tue prenotazioni": "Your bookings", "Metodi di pagamento": "Payment methods",
  "Verifica la tua email": "Verify your email",
  "Soccorso stradale": "Roadside assistance",
  "Email verificata": "Email verified",
  "Proposte di modifica dal gestionale": "Change proposals from the office",
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("fr_lang") || "it");
  useEffect(() => {
    localStorage.setItem("fr_lang", lang);
  }, [lang]);
  const t = (key) => DICT[lang]?.[key] ?? DICT.it[key] ?? key;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

// B5: traduttore per testo letterale dell'area clienti (usa con {tr("...")}) — legge la lingua salvata in home
export const tr = (s) => (typeof window !== "undefined" && (window.localStorage.getItem("fr_lang") || "it") === "en" ? ACC_EN[s] || s : s);

export const LanguageSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1 text-[10px] font-bold" data-testid="lang-switch">
      {["it", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`uppercase px-1.5 py-1 rounded transition-colors ${lang === l ? "bg-fr-navy text-white" : "text-gray-400 hover:text-fr-navy"}`}
          data-testid={`lang-${l}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
